"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var react_router_dom_1 = require("react-router-dom");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            color: theme.palette.grey[400],
            fontWeight: 'bold',
            textDecoration: 'none',
            transition: theme.transitions.create(['color'], {
                duration: theme.transitions.duration.shortest,
            }),
            marginTop: -6,
            '&:hover': {
                color: theme.palette.primary.light,
            },
        },
    });
});
var Logo = function (_a) {
    var classNameProp = _a.className, other = __rest(_a, ["className"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(react_router_dom_1.Link, __assign({ to: "/dashboard", className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.Typography, { variant: "h3" },
            "21",
            react_1.default.createElement("sup", null, "st"),
            " Night")));
};
exports.default = Logo;
//# sourceMappingURL=Logo.js.map